import React, { createContext, useContext } from 'react';
import supabaseClient from '../supabase/supabase';

const SupabaseContext = createContext(supabaseClient);

export const useSupabase = () => {
  const context = useContext(SupabaseContext);
  if (!context) {
    throw new Error('useSupabase must be used within a SupabaseProvider');
  }
  return context;
};

export const SupabaseProvider = ({ children }) => {
  return (
    <SupabaseContext.Provider value={supabaseClient}>
      {children}
    </SupabaseContext.Provider>
  );
};

export const supabase = supabaseClient;